import { FormikProps } from "formik";
import {
  OpretFirmaStep1Formik,
  OpretFirmaStep2Formik,
} from "../../opretFirmaInterface";
import { SelectFormik } from "../../../../formcontrols/Select";
import { TextInputFormik } from "../../../../formcontrols/InputItem";
import Spinner from "../../../../spinner/Spinner";
import { useKodeListe } from "../../../../../hooks/useQueries";

const OpretFirmaFakturering = ({
  formik,
  step1Values,
}: {
  formik: FormikProps<OpretFirmaStep2Formik>;
  step1Values: OpretFirmaStep1Formik;
}) => {
  const { kodeliste, getKodelisteError, getKodelisteIsLoading } = useKodeListe(
    "FakturaAfsendelseKode",
  );
  if (getKodelisteError) return <div>Fejl</div>;
  if (getKodelisteIsLoading) return <Spinner />;
  if (!kodeliste) return null;
  const fakturaData: LabelValueType[] = (kodeliste as KodeListeEnumType[]).map(
    (e) => {
      return {
        label: e.navn,
        value: e.id,
      };
    },
  );
  if (!step1Values.produktionsenhed) fakturaData.shift();
  return (
    <>
      <h3 className="mb-n2 flex-100">Fakturering</h3>
      <div>
        <SelectFormik
          config={{
            component: "select",
            id: "fakturaAfsend",
            label: "Faktura afsend standard ",
            isRequired: true,
            placeholder: "Vælg",
          }}
          data={fakturaData}
          formik={formik}
        />
      </div>
      <div>
        <TextInputFormik
          config={{
            component: "textinput",
            id: "emailFaktura",
            initialValue: "",
            label: "E-mail, faktura",
            isRequired: formik.values.fakturaAfsend === "Email",
          }}
          formik={formik}
        />
      </div>
      <div>
        <TextInputFormik
          config={{
            component: "textinput",
            id: "ean",
            initialValue: "",
            label: "EAN-nummer",
            isRequired: formik.values.fakturaAfsend === "Ean",
          }}
          formik={formik}
        />
      </div>
    </>
  );
};

export default OpretFirmaFakturering;
